"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FiltersPanel = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DeviceDisplaySwitch = require("./DeviceDisplaySwitch");
var _FiltersPanelContent = require("./FiltersPanelContent");
var _FilterTypes = require("./FilterTypes");
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FiltersPanel = props => {
  const {
    config,
    objectId,
    typeDisplay,
    setTypeDisplay
  } = props;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_FiltersPanelContent.FiltersPanelContent, {
    config: config,
    objectId: objectId
  }), /*#__PURE__*/_react.default.createElement(_DeviceDisplaySwitch.DeviceDisplaySwitch, {
    typeDisplay: typeDisplay,
    setTypeDisplay: setTypeDisplay
  }));
};
exports.FiltersPanel = FiltersPanel;
FiltersPanel.propTypes = {
  config: _FilterTypes.ConfigType.isRequired,
  objectId: _propTypes.default.string,
  typeDisplay: _propTypes.default.oneOf([_constants.contentType.layoutGrid, _constants.contentType.table]),
  setTypeDisplay: _propTypes.default.func.isRequired
};
FiltersPanel.defaultProps = {
  objectId: 'id',
  typeDisplay: _constants.contentType.layoutGrid
};